import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, BoxExtendedProps, LinkButton, Text } from '@common-fe/common-fe';

import { useMyMoneyNavigation } from '@/modules/UseMyMoney/hooks';
import { ClaimSummaryField } from '@/modules/UseMyMoney/UseMyMoney.types';

const SelectADateOfServiceFirstWarning: React.FC<BoxExtendedProps> = (props) => {
  const { t } = useTranslation();
  const { handleSetActiveField } = useMyMoneyNavigation();

  const handleSelectDateOfService = useCallback(() => {
    handleSetActiveField(ClaimSummaryField.DATE_OF_SERVICE);
  }, [handleSetActiveField]);

  return (
    <Box
      data-testId="select-a-date-of-service-first_warning-message"
      pad="spacing16"
      background="missingContainer"
      round="container2Round"
      {...props}
    >
      <Text weight={700}>
        {t('Select a date of service first')}
      </Text>

      <Text margin={{ top: 'spacing2' }}>
        {t('We need your date of service to show which services your accounts cover.')}
      </Text>

      <Box margin={{ top: 'spacing2' }}>
        <LinkButton
          testId="select-a-date-of-service-first_warning-message"
          onClick={handleSelectDateOfService}
          linkInlineMode
        >
          {t('Select Date of Service')}
        </LinkButton>    
      </Box>
    </Box>
  );
};

export default SelectADateOfServiceFirstWarning;
